import { Button } from '@liveauctioneers/hammer-ui-core/button';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { BidConsoleOpener } from '@/components/BidConsoleOpener/BidConsoleOpener';
import { useAppSelector } from '@/redux/hooks';
import {
    getCatalogIsCatalogOnly,
    getCatalogStartTime,
    getCatalogStatus,
} from '@/redux/modules/catalog/catalogs/catalog.selectors';
import { getIsWhiteLabel } from '@/redux/modules/whiteLabel';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';
import { shouldShowLive } from '@/utils/live';

import { CatalogRegistrationButton } from './CatalogRegistrationButton';

type Props = {
    catalogId: number;
    className?: string;
    forceIsLive: boolean;
};

export const TimedOrLiveAuctionStatusExperiment = ({ catalogId, className, forceIsLive }: Props) => {
    const formatMessage = useAppFormatMessage();

    const isWhiteLabel = useAppSelector(getIsWhiteLabel);
    const saleStartTs = useAppSelector((state) => getCatalogStartTime(state, catalogId));
    const catalogStatus = useAppSelector((state) => getCatalogStatus(state, catalogId));
    const isCatalogOnly = useAppSelector((state) => getCatalogIsCatalogOnly(state, catalogId));

    const isLive = forceIsLive ? true : shouldShowLive(catalogStatus, isCatalogOnly, saleStartTs);

    return (
        <div
            className={cn('flex h-full max-w-full flex-col items-center justify-start gap-xs', className)}
            data-testid="timed-or-live-auction-status-experiment"
        >
            {isLive && (
                <BidConsoleOpener
                    catalogId={catalogId}
                    shouldTrackEnterLiveAuction
                >
                    <Button
                        className="w-full"
                        data-testid="catalogEnterLiveAuctionButton"
                        style={isWhiteLabel ? 'primary' : 'critical'}
                        variant="filled"
                    >
                        {formatMessage(['enter_live_auction'])}
                    </Button>
                </BidConsoleOpener>
            )}
            <CatalogRegistrationButton
                catalogId={catalogId}
                isLive={isLive}
            />
        </div>
    );
};
